export const AUTOLOG_COOKIE_KEY = 'autolog';
